import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";

import {
  REQUEST_AGENCIES,
  requestAgenciesStarted,
  setAgencies,
  setAgenciesError,
} from "@/components/currentUser/Agencies.state";
import {
  getCurrentUserClientBrand,
  getCurrentUserAgencyNames,
} from "@/components/currentUser/CurrentUser.state";
import { getAgencies } from "@/APIClient";
import { requestEpic } from "@/APIClient/observable.util";
import { getAuthToken } from "@/util/session";

const requestAgenciesEpic = (action$, state$) =>
  action$.pipe(
    ofType(REQUEST_AGENCIES),
    RxOp.mergeMap(() =>
      Rx.concat([
        Rx.of(requestAgenciesStarted()),
        requestEpic({
          requestMethod: getAgencies,
          requestArgs: {
            client: getCurrentUserClientBrand(state$.value),
            agencies: getCurrentUserAgencyNames(state$.value),
            token: S.fromMaybe("")(getAuthToken()),
          },
          onSuccess: (res) =>
            Rx.of.apply(this, [setAgencies(S.fromEither({})(res))]),
          onFailure: (err) => Rx.of(setAgenciesError({ error: err })),
        }),
      ])
    ),
    RxOp.concatAll(),
    RxOp.catchError((err) => Rx.of(setAgenciesError({ error: err.message })))
  );

export default requestAgenciesEpic;
